import { render, staticRenderFns } from "./BusinessArticle.vue?vue&type=template&id=25d022f4&scoped=true&"
import script from "./BusinessArticle.vue?vue&type=script&lang=js&"
export * from "./BusinessArticle.vue?vue&type=script&lang=js&"
import style0 from "./BusinessArticle.vue?vue&type=style&index=0&id=25d022f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d022f4",
  null
  
)

export default component.exports